// $app SDK for authenticated API calls to your Cloudflare Worker
// Usage: $app.request('/customers-db?id=123')
// Handles JWT session, storage, and logout

(function (global) {
  const WORKER_BASE = 'https://rexall-query.software-93f.workers.dev'; // <-- CHANGE THIS TO YOUR WORKER URL
  const SESSION_ENDPOINT = WORKER_BASE + '/start-session';
  const JWT_KEY = '_jt;';
  const test = ""




})(typeof window !== 'undefined' ? window : this);

